var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("bank_accounts.manual_reconciliation") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "m-0 pb-3" },
            [
              _c(
                "b-col",
                { attrs: { cols: "2" } },
                [
                  !_vm.isSmartphoneOS
                    ? _c("back-button", { attrs: { returnUrl: _vm.returnUrl } })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.error
            ? _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "text-center my-5" }, [
                    _c("p", { staticClass: "text-secondary" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("common.error_fetch_data")) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "text-primary link",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.fetchData.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("common.rfrsh_page")) +
                            " "
                        ),
                        _c("f7-icon", { attrs: { fa: "refresh" } }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.error
            ? _c(
                "b-row",
                [
                  _c("b-col"),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-form-select", {
                        staticClass: "fs-13px",
                        attrs: { options: _vm.accounts },
                        model: {
                          value: _vm.selectedAccount,
                          callback: function ($$v) {
                            _vm.selectedAccount = $$v
                          },
                          expression: "selectedAccount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.error
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-card-group",
                        { attrs: { deck: "" } },
                        [
                          _c(
                            "b-card",
                            {
                              attrs: {
                                "no-body": "",
                                header: _vm.$t(
                                  "bank_accounts.pending_payments"
                                ),
                              },
                            },
                            [
                              !_vm.rawData
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-center py-2 fs-13px",
                                    },
                                    [
                                      _c("b-spinner", {
                                        staticClass: "greenFont",
                                      }),
                                    ],
                                    1
                                  )
                                : _vm.dpAll.length === 0 &&
                                  _vm.rtpAll.length === 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-center my-3 fs-13px",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "bank_accounts.no_pending_payments"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "b-list-group",
                                    { attrs: { flush: "" } },
                                    [
                                      _vm.dpAll && _vm.dpAll.length > 0
                                        ? _c(
                                            "b-form-checkbox-group",
                                            {
                                              model: {
                                                value: _vm.dpList,
                                                callback: function ($$v) {
                                                  _vm.dpList = $$v
                                                },
                                                expression: "dpList",
                                              },
                                            },
                                            _vm._l(
                                              _vm.dpAll,
                                              function (operation) {
                                                return _c(
                                                  "b-list-group-item",
                                                  {
                                                    key: operation.idOperationStatement,
                                                    staticClass:
                                                      "d-flex justify-content-between align-middle",
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "d-flex flex-column",
                                                        attrs: {
                                                          for:
                                                            "dp-" +
                                                            operation.idOperationStatement,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                operation.remittanceInformation
                                                              ) +
                                                              " | " +
                                                              _vm._s(
                                                                operation.personName
                                                              ) +
                                                              " |\n                      "
                                                          ),
                                                          operation.direction ===
                                                          "1"
                                                            ? _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "text-success",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "+" +
                                                                      _vm._s(
                                                                        operation.amount
                                                                      ) +
                                                                      _vm._s(
                                                                        _vm.currency
                                                                      )
                                                                  ),
                                                                ]
                                                              )
                                                            : _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "text-danger",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "-" +
                                                                      _vm._s(
                                                                        operation.amount
                                                                      ) +
                                                                      _vm._s(
                                                                        _vm.currency
                                                                      )
                                                                  ),
                                                                ]
                                                              ),
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("small", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.date(
                                                                operation.date
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("b-form-checkbox", {
                                                      attrs: {
                                                        value:
                                                          operation.idOperationStatement,
                                                        id:
                                                          "dp-" +
                                                          operation.idOperationStatement,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.rtpAll && _vm.rtpAll.length > 0
                                        ? _c(
                                            "b-form-checkbox-group",
                                            {
                                              model: {
                                                value: _vm.rtpList,
                                                callback: function ($$v) {
                                                  _vm.rtpList = $$v
                                                },
                                                expression: "rtpList",
                                              },
                                            },
                                            _vm._l(
                                              _vm.rtpAll,
                                              function (operation) {
                                                return _c(
                                                  "b-list-group-item",
                                                  {
                                                    key: operation.idOperationStatement,
                                                    staticClass:
                                                      "d-flex justify-content-between align-middle",
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "d-flex flex-column",
                                                        attrs: {
                                                          for:
                                                            "rtp-" +
                                                            operation.idOperationStatement,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                operation.remittanceInformation
                                                              ) +
                                                              " | " +
                                                              _vm._s(
                                                                operation.personName
                                                              ) +
                                                              " |\n                      "
                                                          ),
                                                          operation.direction ===
                                                          "1"
                                                            ? _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "text-success",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "+" +
                                                                      _vm._s(
                                                                        operation.amount
                                                                      ) +
                                                                      _vm._s(
                                                                        _vm.currency
                                                                      )
                                                                  ),
                                                                ]
                                                              )
                                                            : _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "text-danger",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "-" +
                                                                      _vm._s(
                                                                        operation.amount
                                                                      ) +
                                                                      _vm._s(
                                                                        _vm.currency
                                                                      )
                                                                  ),
                                                                ]
                                                              ),
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("small", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.date(
                                                                operation.date
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("b-form-checkbox", {
                                                      attrs: {
                                                        value:
                                                          operation.idOperationStatement,
                                                        id:
                                                          "dp-" +
                                                          operation.idOperationStatement,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-card-group",
                        { attrs: { deck: "" } },
                        [
                          _c(
                            "b-card",
                            {
                              attrs: {
                                "no-body": "",
                                header: _vm.$t("bank_accounts.bank_operations"),
                              },
                            },
                            [
                              !_vm.rawData
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-center py-2 fs-13px",
                                    },
                                    [
                                      _c("b-spinner", {
                                        staticClass: "greenFont",
                                      }),
                                    ],
                                    1
                                  )
                                : _vm.opAll.length === 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-center my-3 fs-13px",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "bank_accounts.no_operations_to_reconcile"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "b-list-group",
                                    { attrs: { flush: "" } },
                                    [
                                      _c(
                                        "b-form-checkbox-group",
                                        {
                                          model: {
                                            value: _vm.opList,
                                            callback: function ($$v) {
                                              _vm.opList = $$v
                                            },
                                            expression: "opList",
                                          },
                                        },
                                        _vm._l(_vm.opAll, function (operation) {
                                          return _c(
                                            "b-list-group-item",
                                            {
                                              key: operation.idOperationStatement,
                                              staticClass:
                                                "d-flex justify-content-start align-middle",
                                            },
                                            [
                                              _c("b-form-checkbox", {
                                                attrs: {
                                                  value:
                                                    operation.idOperationStatement,
                                                  id:
                                                    "op-" +
                                                    operation.idOperationStatement,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "d-flex flex-column",
                                                  attrs: {
                                                    for:
                                                      "op-" +
                                                      operation.idOperationStatement,
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          operation.remittanceInformation
                                                        ) +
                                                        " | " +
                                                        _vm._s(
                                                          operation.personName
                                                        ) +
                                                        " |\n                      "
                                                    ),
                                                    operation.direction === "1"
                                                      ? _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "text-success",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "+" +
                                                                _vm._s(
                                                                  operation.amount
                                                                ) +
                                                                _vm._s(
                                                                  _vm.currency
                                                                )
                                                            ),
                                                          ]
                                                        )
                                                      : _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "-" +
                                                                _vm._s(
                                                                  operation.amount
                                                                ) +
                                                                _vm._s(
                                                                  _vm.currency
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("small", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.date(operation.date)
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        }),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "accordionForm mt-3 justify-content-end" },
            [
              _c(
                "b-col",
                {
                  staticClass: "form-group p-0 pr-2",
                  attrs: { md: "2", offset: "8" },
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", size: "md" },
                      on: {
                        click: function ($event) {
                          return _vm.rapprocher()
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("bank_accounts.reconcile_operations")
                            ) +
                            " "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.buttonLoad
                        ? _c("b-spinner", {
                            attrs: { small: "", variant: "light" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }